import React, { useEffect, useRef, useState } from 'react';
import { Query, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import FullLayout2 from '../asyncIntake/screens/components/FullLayout';
import { isMobile } from 'react-device-detect';
import Div100vh, { measureHeight } from 'react-div-100vh';
import withAnalytics from '../../lib/withAnalytics';
import { ExplorePlans } from './components/ExplorePlans';
import { ComponentWrap } from './components/ComponentWrap';
import { SingleSelect } from './components/SingleSelect';
import { Steps, Step, Wizard } from 'react-albus';
import { GoalTransition } from './components/GoalTransition';
import { Flex } from 'rebass';
import theme from '../../styles/theme';
import { GoalReassurance } from './components/GoalReassurance';
import { PickState } from './components/PickState';
import { Dob } from './components/Dob';
import { Eligible1 } from './components/Eligible1';
import { HeightWeight } from './components/HeightWeight';
import { Bmi } from './components/Bmi';
import { ExperiencedDiagnosed, OPTIONS as OPTIONS_DIAGNOSED } from './components/ExperiencedDiagnosed';
import { ConditionsNext, OPTIONS as OPTIONS_CONDITIONS_NEXT } from './components/ConditionsNext';
import { Conditions, OPTIONS as OPTIONS_CONDITIONS } from './components/Conditions';
import { SexAtBirth } from './components/SexAtBirth';
import { Results, TooYoung } from './components/Results';
import gql from 'graphql-tag';
import PleaseWait from '../../components/PleaseWait';
import { Reset } from './components/Reset';
import moment from 'moment';
import { LearnMoreModal } from '../asyncIntake/screens/LearnMoreModal';
import { sleep } from '../../utils/sleep';
import { removeRetellWidget } from '../../utils/retellWidget';

const STATES_ELIGIBILITY = gql`
  query statesEligibilities {
    statesEligibilities {
      id
      label
      value
      level
      canBookNutritionist
      canBookAsync
      canBookPeriMenopause
      canBookPostMenopause
      canBookWeightLoss
    }
  }
`;

const Pb = styled(Flex)`
  transition: all 0.35s ease;
`;

const Container = styled(Flex)`
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow-y: auto; //${(props) => (isMobile ? 'auto' : '')};
  display: flex;
  flex-direction: column;
`;

const STEPS_CONTROL = [
  {
    id: 'welcome',
    set: [],
    requisite: [],
  },
  {
    id: 'weightLossGoal',
    set: ['weightLossGoal'],
    requisite: [],
  },
  {
    id: 'goals-transition',
    set: [],
    requisite: ['weightLossGoal'],
  },
  {
    id: 'goals-reassurance',
    set: [],
    requisite: ['weightLossGoal'],
  },
  {
    id: 'select-state',
    set: ['prestate'],
    requisite: ['weightLossGoal'],
  },
  {
    id: 'dob',
    set: ['dob'],
    requisite: ['weightLossGoal', 'prestate'],
  },
  {
    id: 'sex-at-birth',
    set: ['assignedsexatbirth'],
    requisite: ['weightLossGoal', 'prestate', 'dob'],
  },
  {
    id: 'height-weight',
    set: ['feet', 'inches', 'pounds', 'bmi'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth'],
  },
  {
    id: 'previous-glp1',
    set: ['previousGlp1'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'glp1-stopped',
    set: ['stoppedGlp1'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', 'previousGlp1'],
  },
  {
    id: 'bmi',
    set: [],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'experience-or-diagnosed',
    set: ['_diagnosis'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'conditions',
    set: ['_conditions1'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis'],
  },
  {
    id: 'conditions-next',
    set: ['_conditions2'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1'],
  },
  {
    id: 'good-to-go',
    set: [],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
  },
  {
    id: 'results',
    set: [],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
  },
  {
    id: 'results-other',
    set: [],
    requisite: ['prestate', 'dob', 'assignedsexatbirth'],
  },
  {
    id: 'hypo-diagnosed',
    set: [],
    requisite: ['prestate', 'dob', 'assignedsexatbirth'],
  },
];

const WeightLossPrequalification = ({ history, location, analytics }) => {
  const vh100 = `${measureHeight()}px` || '100vh';
  const [loaded, setLoaded] = useState(false);
  const [step, setStep] = useState(0);
  const [regions, setRegions] = useState();
  const [region, setRegion] = useState();
  const [state, setState] = useState(window.sessionStorage.getItem('wmi') !== null ? JSON.parse(window.sessionStorage.getItem('wmi')) : {});
  const [previousPage, setPreviousPage] = useState();
  const wrapRef = useRef();
  const [learnMoreModal, setLearnMoreModal] = useState(null);

  const checkRequisites = () => {
    const locat = STEPS_CONTROL.find((x) => x.id === location.pathname.replace('/wm/', ''));

    if (!locat) {
      return;
    }

    for (let index = 0; index < locat.requisite.length; index++) {
      const element = locat.requisite[index];

      if (element.indexOf('_') === 0) {
        if (element === '_diagnosis') {
          const opts = OPTIONS_DIAGNOSED;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/wm/${target.id}`);
          }
        }
        if (element === '_conditions1') {
          const opts = OPTIONS_CONDITIONS;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/wm/${target.id}`);
          }
        }
        if (element === '_conditions2') {
          const opts = OPTIONS_CONDITIONS_NEXT;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/wm/${target.id}`);
          }
        }
        continue;
      }

      if (state[element]) {
        // // console.log('found')
      } else {
        // console.log('notFound');
        const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
        if (!target) continue;
        history.replace(`/wm/${target.id}`);
      }
    }
  };

  useEffect(
    () => {
      if (location.pathname !== previousPage) {
        scrollUp();
        let tag = (location.pathname || '').replace('/wm','');
        if (location.pathname.indexOf('basic') > -1) {
          tag = 'basic';
        } else if (location.pathname.indexOf('profile') > -1) {
          tag = 'profile';
        } else if (location.pathname.indexOf('extended') > -1) {
          tag = 'extended';
        }
        if (tag) {
          // console.log('useEffect', tag);
          analytics.page(tag, '/wm');
        }
        setPreviousPage(location.pathname);
        checkRequisites();
      }
    },
    [location]
  );
  
  useEffect(() => {
    const rem = async () => {
      await sleep(500);
              removeRetellWidget();
      // if (window.Beacon) {
      //   window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      // } else {
      //   await sleep(3000);
      //   if (window.Beacon) {
      //     window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      //   }
      // }
      await sleep(3000)
      try {
              removeRetellWidget();
        // window.Beacon('destroy')
      } catch (error) {
        
      }
    };

    rem();
    if (location.pathname.indexOf('reset') > -1) return;

    const wmd = window.localStorage.getItem('wm-d');
    if (!!wmd) {
      if (wmd === 'dob') {
        history.push('/wm/unable-1');
        return;
      }
    }

    const wmi = window.sessionStorage.getItem('wmi');
    if (!!wmi) {
      let w = JSON.parse(window.sessionStorage.getItem('wmi'));
      if (w) {
      }
    }
  }, []);

  const handleChange = (id, value, clearValue) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;
    if (!!clearValue) {
      if (Array.isArray(clearValue)) {
        for (let index = 0; index < clearValue.length; index++) {
          const element = clearValue[index];
          delete s[element];
        }
      } else {
        delete s[clearValue];
      }
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeMultiple = (idValues) => {
    const s = JSON.parse(JSON.stringify(state));
    for (let index = 0; index < idValues.length; index++) {
      const element = idValues[index];
      const { id, value } = element;
      s[id] = value;
    }

    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeHeightWeight = (id, value) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;

    delete s['previousGlp1'];
    delete s['stoppedGlp1'];

    if (s['feet'] && (s['inches'] || s['inches'] === 0) && s['pounds']) {
      let centimeters = (parseInt(s['feet'] || 0, 10) * 12 + parseInt(s['inches'] || 0, 10)) * 2.54;
      let grams = parseFloat((s['pounds'] || '').replace(/ /g, '') || '0') * 453.6;

      const bmi = ((grams / 1000 / centimeters / centimeters) * 10000).toFixed(2);
      s['bmi'] = bmi;
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const determineNextFromDiagnosed = () => {
    if ((!!region && !region.canBookWeightLoss) || state['bmi'] < 22) {
      window.localStorage.setItem('wm-d', 'stateOrBMI');
      return 'conditions';
    }

    if (state['bmi'] >= 24) {
      return 'conditions';
    }


    if (state['previousGlp1']==='neverGlp1' || state['previousGlp1']==='moreThan3Months') {
      // console.log(3)
      //disqualify GLP1
      window.localStorage.setItem('wm-d', 'bmi');
      // return 'results';
    }
    return 'conditions';
  };

  const scrollUp = () => {
    if (wrapRef && wrapRef.current) {
      wrapRef.current.scrollTo(0, 0);
    } else {
      // console.log('no ref');
    }
  };

  return (
    <FullLayout2
      style={{
        zIndex: 11,
        overflowY: 'auto',
        maxHeight: '',
        paddingLeft: location.pathname !== '/wm/results-other' &&location.pathname !== '/wm/results' ? '12px' : 0,
        paddingRight: location.pathname !== '/wm/results-other' &&location.pathname !== '/wm/results' ? '12px' : 0,
      }}
      pb={5}
      innerRef={wrapRef}
    >
      <Container
        style={{
          height: 'auto !important',
          minHeight: vh100,
          maxWidth: location.pathname !== '/wm/results-other' && location.pathname !== '/wm/results' && location.pathname !== '/wm/unable-1' ? '600px' : '',
          overflow: 'hidden',
        }}
      >
        <Query
          query={STATES_ELIGIBILITY}
          onCompleted={(e) => {
            setRegions(e.statesEligibilities);
            if (state['prestate'] && e.statesEligibilities) {
              setRegion(e.statesEligibilities.find((x) => x.value === state['prestate']));
              // setLoaded
            }
          }}
        >
          {({ loading, error, data }) => {
            if (!!loading) {
              return <PleaseWait />;
            }

            return (
              <Wizard
                history={history}
                basename="/wm"
                render={({ step, ...p }, a) => {
                  // // console.log({ p, a, step });
                  return (
                    <>
                      {step.id !== 'results' && (
                        <Flex flexDirection={'row'} style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }} pt={2} id="pgbar">
                          <Flex flexDirection={'row'} style={{ width: '100%', height: '6px' }}>
                            <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)' }} flex={1} id="ttt">
                              <Pb
                                flex={step.id === 'results' || step.id === 'results-other' || step.id === 'unable-1' ? 1 : (p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length}
                                style={{ background: theme.color.pink, borderTopRightRadius: '3px', borderBottomRightRadius: '3px' }}
                              />
                              <Pb
                                flex={step.id === 'results' || step.id === 'results-other' || step.id === 'unable-1' ? 0 : 1 - (p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length}
                                style={{ background: 'transparent' }}
                              />
                            </Flex>
                            <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                            <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                          </Flex>
                        </Flex>
                      )}
                      <Steps>
                        <Step id="welcome">
                          <ComponentWrap>
                            <ExplorePlans onContinue={() => p.push('goals')} />
                          </ComponentWrap>
                        </Step>
                        <Step id="goals">
                          <ComponentWrap>
                            <SingleSelect
                              onChange={handleChange}
                              onContinue={() => p.push('goals-transition')}
                              id={'weightLossGoal'}
                              state={state}
                              title={`What’s your weight loss goal?`}
                              options={[
                                {
                                  value: '1-15',
                                  label: 'Losing 1-15 lbs',
                                },
                                {
                                  value: '16-50',
                                  label: 'Losing 16-50 lbs',
                                },
                                {
                                  value: '51+',
                                  label: 'Losing 51+ lbs',
                                },
                                {
                                  value: 'notSure',
                                  label: 'Not sure, I just need to lose weight',
                                },
                              ]}
                            />
                          </ComponentWrap>
                        </Step>
                        <Step id="goals-transition">
                          <ComponentWrap>
                            <GoalTransition state={state} onContinue={() => p.push('goals-reassurance')} />
                          </ComponentWrap>
                        </Step>

                        <Step id="goals-reassurance">
                          <ComponentWrap>
                            <GoalReassurance state={state} onContinue={() => p.push('select-state')} />
                          </ComponentWrap>
                        </Step>

                        <Step id="select-state">
                          <ComponentWrap>
                            <PickState
                              regions={data.statesEligibilities}
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                p.push('dob');
                              }}
                              setRegion={(region) => setRegion(region)}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="dob">
                          <ComponentWrap>
                            <Dob
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                const dob = state['dob'];
                                if (moment().diff(moment(dob, 'MM/DD/YYYY'), 'year') < 18) {
                                  window.localStorage.setItem('wm-d', 'dob');
                                  p.push('unable-1');
                                  return;
                                }
                                p.push('sex-at-birth');
                              }}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="sex-at-birth">
                          <ComponentWrap>
                            <SexAtBirth
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                if (!!region && !region.canBookWeightLoss) {
                                  window.localStorage.setItem('wm-d', 'noWl');
                                  p.push('hypo-diagnosed');
                                  return;
                                }
                                p.push('height-weight');
                              }}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="height-weight">
                          <ComponentWrap>
                            <HeightWeight
                              state={state}
                              onChange={handleChangeHeightWeight}
                              onContinue={() => {
                                const bmi = state['bmi'];
                                if(bmi<22){
                                  p.push('experience-or-diagnosed');
                                  return
                                }
                                if (bmi >= 22 && bmi < 24) {
                                  p.push('previous-glp1');
                                } else {
                                  p.push('bmi');
                                }
                              }}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="previous-glp1">
                          <ComponentWrap>
                            <SingleSelect
                              onChange={(id, value) => {
                                handleChangeMultiple([{ id, value }, { id: 'stoppedGlp1', value: null }]);
                              }}
                              onContinue={() => {
                                const previousGlp1 = state['previousGlp1'];

                                if (previousGlp1 !== 'stopped') {
                                  p.push('experience-or-diagnosed');
                                } else {
                                  p.push('glp1-stopped');
                                }
                              }}
                              id={'previousGlp1'}
                              state={state}
                              title={`Are you currently or have you ever taken a GLP-1 medication?`}
                              options={[
                                {
                                  value: 'currentlyTakingGlp1',
                                  label: 'I am currently taking a glp-1 medication',
                                },
                                {
                                  value: 'stoppedGlp1',
                                  label: `I have taken a GlP-1 medication but I'm not currently`,
                                },
                                {
                                  value: 'neverGlp1',
                                  label: 'I have never took a GLP-1 medication',
                                },
                              ]}
                            />
                          </ComponentWrap>
                        </Step>
                        <Step id="glp1-stopped">
                          <ComponentWrap>
                            <SingleSelect
                              onChange={handleChange}
                              onContinue={() => p.push('experience-or-diagnosed')}
                              id={'stoppedGlp1'}
                              state={state}
                              title={`When did you stop taking your last dose of GLP-1 Medication?`}
                              options={[
                                {
                                  value: 'withinLast2weeks',
                                  label: 'Within the last 2 weeks',
                                },
                                {
                                  value: 'lessThan3months',
                                  label: `More than 2 weeks and less than 3 months ago`,
                                },
                                {
                                  value: 'moreThan3Months',
                                  label: 'More than 3 months ago',
                                },
                              ]}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="bmi">
                          <ComponentWrap>
                            <Bmi
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                p.push('experience-or-diagnosed');
                              }}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="experience-or-diagnosed">
                          <ComponentWrap>
                            <ExperiencedDiagnosed state={state} onChange={handleChange} onContinue={() => p.push(determineNextFromDiagnosed())} />
                          </ComponentWrap>
                        </Step>

                        <Step id="conditions">
                          <ComponentWrap>
                            <Conditions
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                if (state['pregnant'] || state['tryingpregnant'] || state['breastfeeding'] || state['diabetesInsulin']) {
                                  window.localStorage.setItem('wm-d', 'conditions1');
                                  p.push('results');
                                  return;
                                }
                                p.push('conditions-next');
                              }}
                            />
                          </ComponentWrap>
                        </Step>

                        <Step id="conditions-next">
                          <ComponentWrap>
                            <ConditionsNext
                              state={state}
                              onChange={handleChange}
                              onContinue={() => {
                                if (!state['noneConditionsNext']) {
                                  window.localStorage.setItem('wm-d', 'conditions2');
                                  p.push('results');
                                  return;
                                }
                                p.push('results');
                              }}
                            />
                          </ComponentWrap>
                        </Step>
{/* 
                        <Step id="good-to-go">
                          <ComponentWrap>
                            <Eligible1 state={state} onChange={handleChange} onContinue={() => p.push('results')} />
                          </ComponentWrap>
                        </Step> */}

                        <Step id="results">
                          <Results state={state} onChange={handleChange} onContinue={() => history.push('/wm-registration')} region={region} 
                            showLearnMore={(learnMoreId) => setLearnMoreModal(learnMoreId)}/>
                        </Step>

                        <Step id="hypo-diagnosed">
                          <ComponentWrap>
                            <SingleSelect
                              onChange={handleChange}
                              onContinue={() => {
                                p.push('results-other');
                              }}
                              id={'hypothyroidism'}
                              state={state}
                              title={`Were you previously diagnosed with hypothyroidism?`}
                              options={[
                                {
                                  value: 'yes',
                                  label: 'Yes',
                                },
                                {
                                  value: 'no',
                                  label: `No`,
                                },
                                {
                                  value: 'abnormalLabs',
                                  label: 'I have abnormal labs I can upload',
                                },
                              ]}
                            />
                          </ComponentWrap>
                        </Step>
                        <Step id="results-other">
                          <Results
                            state={state}
                            onChange={handleChange}
                            onContinue={() => history.push('/wm-registration')}
                            region={region}
                            showLearnMore={(learnMoreId) => setLearnMoreModal(learnMoreId)}
                          />
                        </Step>
                        <Step id="reset">
                          <Reset />
                        </Step>
                        <Step id="unable-1">
                          <TooYoung />
                        </Step>
                      </Steps>
                    </>
                  );
                }}
              />
            );
          }}
        </Query>
      </Container>
      {learnMoreModal && <LearnMoreModal learnMoreId={learnMoreModal} onClose={() => setLearnMoreModal(null)} />}
    </FullLayout2>
  );
};

export default withAnalytics(withApollo(withRouter(WeightLossPrequalification)));
